export { FADE_IN_OUT_ANIMATION } from './fade-in-out';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/animations/index.ts